import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      gap: 16,
      alignItems: 'center',
      borderRadius: 12,

      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        backgroundColor: '#fff',
        padding: '8px 24px 8px 8px',
      },
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    },
    thumb: {
      height: 120,
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    download: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
    },
    apps: {
      display: 'flex',
      gap: 12,
    },
    app: {
      height: 40,
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
      alignItems: 'center',
    },
    img: {
      width: rem(160),
    },
    button: {},
  }
})
